// EmailEngagementMediaQuery.ts

export const TitleMediaQuery = `
  @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
    .ant-typography-ellipsis-single-line {
      max-width: 220px;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1) {
    font-size: 16px;
    .ant-typography-ellipsis-single-line {
      max-width: 140px;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1.25) {
    font-size: 13px;
    .ant-typography-ellipsis-single-line {
      max-width: 140px;
    }
  }
  @media all and (min-width: 1500px) and (max-width: 1700px) {
    .ant-typography-ellipsis-single-line {
      max-width: 280px;
    }
  }
  @media all and (min-width: 1900px) {
    .ant-typography-ellipsis-single-line {
      max-width: 25rem;
    }
  }
  @media all and (max-width: 1024px) {
    font-size: 13px;
    .ant-typography-ellipsis-single-line {
      max-width: 120px;
    }
  }
`;

export const SubtitleMediaQuery = `
  @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
    .ant-typography-ellipsis-single-line {
      max-width: 165px;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1) {
    font-size: 13px;
    .ant-typography-ellipsis-single-line {
      max-width: 95px;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1.25) {
    font-size: 13px;
    .ant-typography-ellipsis-single-line {
      max-width: 100px;
    }
  }
  @media all and (min-width: 1500px) and (max-width: 1700px) {
    .ant-typography-ellipsis-single-line {
      max-width: 230px;
    }
  }
  @media all and (min-width: 1900px) {
    .ant-typography-ellipsis-single-line {
      max-width: 22rem;
    }
  }
  @media all and (max-width: 1024px) {
    font-size: 13px;
    .ant-typography-ellipsis-single-line {
      max-width: 76px;
    }
  }
`;

export const campaignWorkflowMediaQuery = `
@media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
    .ant-typography-ellipsis-single-line {
      max-width: 145px;
    }
  }
  @media all and (max-width: 1280px) {
    font-size: 13px;
    .ant-typography-ellipsis-single-line {
      max-width: 110px;
    }
  }
`;
